import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/colors-static.css'
import '@/assets/css/colors-custom.css'
import '@/assets/css/kendo.css'
import '../theme/index.css'
import './assets/css/tailwind.css'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import { i18n } from '@/i18n'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/es'
import { Outside } from '@/components/directives/Outside.js'
import { registerAccessibleElSwitch } from '@/components/directives/SwitchAccessibility.js'
import { registerAccessibleElDatePicker } from '@/components/directives/DatePickerAccessibility.js'
import { initKeyboardFocusVisible } from '@/components/directives/KeyboardFocusVisible.js'
import { initElClearFocusRestore } from '@/components/directives/ElClearFocusRestore.js'
import { feedbackMixin, numberFilter } from '@/mixins/appMixin'
import { getDateFormat } from '@/i18n/dates'
import '@/components/base/_globals'
import 'nprogress/nprogress.css'
import VueFilterDateFormat from 'vue-filter-date-format'

import { load } from '@progress/kendo-vue-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import 'vue-loading-overlay/dist/vue-loading.css'

import IdleVue from 'idle-vue'
import VueTour from 'vue-tour'

import 'vue-pdf-app/dist/icons/main.css'
import VuePdfApp from 'vue-pdf-app'

require('vue-tour/dist/vue-tour.css')

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
)

Vue.use(vueNumeralFilterInstaller, { locale: 'es-es' })
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

// Sobrescribe ElOption para que el filtro de el-select sea accent-insensitive
const normalizeStr = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
const ElOption = Vue.component('ElOption')
Vue.component('ElOption', {
  extends: ElOption,
  methods: {
    queryChange (query) {
      this.visible = normalizeStr(String(this.currentLabel)).includes(normalizeStr(query)) || this.created
      if (!this.visible) {
        this.select.filteredOptionsCount--
      }
    }
  }
})

registerAccessibleElSwitch(Vue)
registerAccessibleElDatePicker(Vue)
Vue.directive('outside', Outside)
Vue.use(VueFilterDateFormat)

Vue.mixin(feedbackMixin)
Vue.mixin(numberFilter)
Vue.filter('date', getDateFormat)

Vue.use(VueTour)
Vue.component('vue-pdf-app', VuePdfApp)

export const bus = new Vue()

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: (process.env.VUE_APP_IDLE_TIME * 1000 * 60), // Minutos
  // idleTime: (process.env.VUE_APP_IDLE_TIME * 1000), // Segundos
  startAtIdle: false
})

new Vue({
  router,
  i18n,
  store,
  watch: {
    '$route' (to) {
      if (to.meta.reload === true) {
        // window.location.reload()
      }
    }
  },
  render: h => h(App)
}).$mount('#app')

var mediaQuery = '(max-width: 1023px)'
window.matchMedia(mediaQuery).addEventListener('change', function () {
  var matched = this.matches
  store.dispatch('app/setIsLower1024', matched)
})
store.dispatch('app/setIsLower1024', window.matchMedia(mediaQuery).matches)

// Accesibilidad (WCAG 2.1 AA - 2.4.7): muestra el foco solo con teclado, no con ratón.
initKeyboardFocusVisible()
// Accesibilidad (WCAG 2.1 AA - 2.4.3): restaura el foco al campo tras pulsar el botón de borrado de Element UI.
initElClearFocusRestore()
